// @flow
import { put, takeLatest } from 'redux-saga/effects';
import {
    LOAD_RESOURCES_DETAILS,
} from '../types/resource';
import {
    loadResourcesDetailsSuccess,
    loadResourcesDetailsFail,
} from '../actions/resource';

export function* loadResourcesDetailsSaga( action: { axiosInstance: Object }): Generator<any, void, any> {
    const { axiosInstance, id } = action;
    try {
        const url = `projects/${String(id)}/resources`;
        const result = yield axiosInstance.get(url);
        const { data } = result;
        yield put(loadResourcesDetailsSuccess(data));
    } catch (err) {
        yield put(loadResourcesDetailsFail(err));
    }
};

export function* watchLoadResourcesDetails(): Generator<any, void, any> {
    yield takeLatest(LOAD_RESOURCES_DETAILS, loadResourcesDetailsSaga);
};


// WEBPACK FOOTER //
// ./src/sagas/resource.jsx